import { render, staticRenderFns } from "./newLiaoBan.vue?vue&type=template&id=5ad54fb2&scoped=true&"
import script from "./newLiaoBan.vue?vue&type=script&lang=js&"
export * from "./newLiaoBan.vue?vue&type=script&lang=js&"
import style0 from "./newLiaoBan.vue?vue&type=style&index=0&id=5ad54fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad54fb2",
  null
  
)

export default component.exports